export default __webpack_public_path__ + "static/assets/b7131f519dbf0880bf469c38c56c4ef3.svg";